/**
 * Reload all linked assets in the asset management interface
 */
window.reloadAllAssets = function() {
  let element = $('#linked_assets');

  if (!element.length) return;

  let ids = $('[path*="load_items=true"]', element).map((_, el) => el.id.replace('linked_asset_', '')).get().join(',');

  let url = new URL(element.attr('src') || element.attr('path'), window.location.origin);
  url.searchParams.set('preload_items', ids);

  element.reload(url.pathname + url.search);
}
